<template>
    <section v-if="hasPermissions(['Building-Room Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>
        <div class="view__description">
            <p class="view__description__text" v-html="'Select the rooms you want to restore the default description. Then click Restore Default Descriptions'"/>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <!-- <div class="input-field my-0" v-if="custom_rooms.length"> -->
                <div class="input-field my-0">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div v-if="hasPermissions(['Building-Room Write'])" class="bar-container__options">
                <button 
                    class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2"
                    v-html="'Restore Default Descriptions'" 
                    :class="{'disabled button__disabled' : !selected}" 
                    :disabled="!selected"
                    @click="restoreDefaultDescriptions()"
                />
            </div>
        </div>

         <div class="tab-content" v-show="custom_rooms.length">
            <div class="row mb-0 no-gutters">
                <div class="col-lg-12">
                    <v-card>
                        <DinamicTable
                            :headers="table_headers"
                            :items="custom_rooms"
                            :search="search"
                            :checkable="true"
                            :link="child_href"
                            :historiable="false"
                            :selectable_columns="false"
                        />
                    </v-card>
                </div>
            </div>
        </div>

        <WaitingModal/>

    </section>
    <section v-else class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="'you do not have permission for this section. contact your system administrator'"/>
    </section>
</template>

<script>
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import Resources        from    './resources'
import DinamicTable     from    '@/components/DinamicTable'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'CustomRoomsComponent',

    components:{
        Breadcrumb,
        WaitingModal,
        DinamicTable,
    },

    data(){
        return{
            notyf,
            child_href:         '/building-room/',
            title_page:         'Custom Room Descriptions',
            content_header:     this.$store.state.headers,
            rest_api:           `assignment_rooms`,
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            add_btn:            'Add Area',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       '',
            single_object:      {},
            custom_rooms:              [],
            array_options:      {},
            select_ids:         [],
            histories:          [],
            history_title:      '',
        }
    },

    methods:{

        async restoreDefaultDescriptions()
        {
            let rooms_selected = this.custom_rooms.filter(item => item.checked)

            if(!rooms_selected.length)
            {
                return false
            }

            this.loader(true)

            let rooms_data = {
                rooms_id: rooms_selected.map(item => item.id)
            }

            let json_request = {
                custom_rooms: true,
            }

            const response = await this.patch(`${this.rest_api}/${JSON.stringify(json_request)}`, rooms_data)

            if(response.status)
            {
                let rooms_id = response.data.rooms_id

                if(rooms_id.length)
                {
                    rooms_id.forEach((item) => 
                    {
                        let index_custom_rooms = this.custom_rooms.findIndex(prop => prop.id === item)

                        if(index_custom_rooms > -1)
                        {
                            this.custom_rooms.splice(index_custom_rooms, 1)
                        }
                    })
                }
                
                notyf.success('Success')
                this.loader()
            } 
            else
            {
                this.error_handling(response)
                this.loader()
            }

        },

        async api_request()
        {
            this.loader(true)

            let json_request = {
                custom_rooms: true,
            }
            
            const response = await this.get(`${this.rest_api}/${JSON.stringify(json_request)}`)

            if(response.status)
            {
                this.fill_data(response.data.custom_rooms)
                this.loader()
            } 
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        fill_data(data)
        {
            this.custom_rooms = data
        },

    },

    async mounted(){
        if(this.hasPermissions(['Building-Room Read']))
        {
            await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.custom_rooms.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
    
}

</script>